"use client";
import React from "react";
import { useTranslation } from "i18n/client";
import { PrivateTemplate } from "@components/templates";
import { Grid, Typography, useTheme, Box, Stack } from "@mui/material";

export const TermsOfUse = ({ htmlContent }: { htmlContent: string }) => {
  const theme = useTheme();
  const { t } = useTranslation("terms-of-use");
  return (
    <PrivateTemplate>
      <Grid container mt="96px" mb="20px">
        <Grid
          item
          lg={6.5}
          md={8}
          sm={10}
          xs={12}
          sx={{
            margin: "0px auto",
          }}
        >
          <Typography
            component="h1"
            variant="Display_lgSemibold"
            color={theme.palette.grey[900]}
            textAlign="center"
            mt="12px"
          >
            {t("heading")}
          </Typography>
          <Typography
            component="p"
            variant="Text_xlNormal"
            color={theme.palette.grey[500]}
            textAlign="center"
            mt="24px"
          >
            {t("subtitle")}
          </Typography>
          <Stack mt="96px" px="24px">
            <div dangerouslySetInnerHTML={{ __html: htmlContent ?? "" }} />
          </Stack>
        </Grid>
      </Grid>
    </PrivateTemplate>
  );
};
